export function createArrowElement(){}


export function updateArrowElement(link,[x1,y1],[x2,y2],asElement,viewStart, viewEnd) {  
  function limitByView(value){
    if(value<viewStart) {return viewStart;}

    if(value>viewEnd) {return viewEnd;}

    return value;
  }

  const left = (x1<x2?x1:x2);
  const top = (y1<y2?y1:y2);

  const {lineWidth:lw, sourceMargin=0, sourceShape = 'none', targetMargin=2,targetShape = 'straight', curvature='0', bends : strbends = 2} = link.currentStyle;
  let {sourceSize,targetSize} = link.currentStyle;
  if(!sourceSize||sourceSize<=0){sourceSize=1;}

  if(!targetSize||targetSize<=0){targetSize=1;}

  const bends = parseInt(strbends);
  let rotation = Math.atan2(y2-y1, x2-x1);
  if (rotation < 0){
    rotation = Math.abs(rotation);
  } else {
    rotation = 2 * Math.PI - rotation;
  }

  let curvatureValue = parseInt(curvature);
  if(curvature.endsWith('%')){
    curvatureValue = curvature.replace('%','');
    curvatureValue = parseInt(curvatureValue);
    curvatureValue = Math.sqrt((x2-x1)**2 + (y2-y1)**2)*curvatureValue/100;
  }

  // const targetK = targetSizes[targetSize]||1;
  const targetK = targetSize;
  const hlw = lw>=8?lw:8;

  const cx = Math.sin(rotation)*curvatureValue;
  const cy = Math.cos(rotation)*curvatureValue;

  const cpx2 = x2 - cx - (x2-x1)/(bends+1);

  const cpy2 = limitByView(y2 - cy - (y2-y1)/(bends+1));
  let trotation = Math.atan2(y2-cpy2, x2-cpx2);
  if (trotation < 0){
    trotation = Math.abs(trotation);
  } else {
    trotation = 2 * Math.PI - trotation;
  }


  const tdx = Math.cos(trotation)*hlw*targetK;
  const tdy = -Math.sin(trotation)*hlw*targetK;

  const tmx = Math.cos(trotation)*targetMargin;
  const tmy = -Math.sin(trotation)*targetMargin;

  const tox = Math.sin(trotation)*lw*0.5;
  const toy = Math.cos(trotation)*lw*0.5;              

  const tkox = Math.sin(trotation)*hlw*0.5*targetK;
  const tkoy = Math.cos(trotation)*hlw*0.5*targetK;

  
  let targetPoints;
  let targetStart;
  switch(targetShape){
    case 'straight':
      targetStart=2;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - 2*tdx - tmx, y2 - top - toy - 2*tdy - tmy],
        [x2 - left - tox - tkox - 2*tdx - tmx, y2 - top - toy - tkoy - 2*tdy - tmy],
        [x2 - left - tmx, y2-top-tmy],
        [x2 - left + tox + tkox - 2*tdx - tmx, y2 - top + toy + tkoy - 2*tdy - tmy],
        [x2 - left + tox - 2*tdx - tmx, y2 - top + toy - 2*tdy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
    case 'triangular':
    targetStart=1;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - tdx - tmx, y2 - top - toy - tdy - tmy],
        [x2 - left - (tox + tkox) - tdx - tmx, y2 - top - (toy+tkoy) - tdy - tmy],
        [x2 - left - tmx, y2-top-tmy],
        [x2 - left + (tox + tkox) - tdx - tmx, y2 - top + (toy+tkoy) - tdy - tmy],
        [x2 - left + tox - tdx - tmx, y2 - top + toy - tdy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
    case 'notched':
    targetStart=1.7;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - 1.7*tdx - tmx, y2 - top - toy - 1.7*tdy - tmy],
        [x2 - left - (tox + tkox) - 2*tdx - tmx, y2 - top - (toy+tkoy) - 2*tdy - tmy],
        [x2 - left - tmx, y2-top-tmy],
        [x2 - left + (tox + tkox) - 2*tdx - tmx, y2 - top + (toy+tkoy) - 2*tdy - tmy],
        [x2 - left + tox - 1.7*tdx - tmx, y2 - top + toy - 1.7*tdy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
    case 'rombic':
    targetStart=3;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - 3*tdx - tmx, y2 - top - toy - 3*tdy - tmy],
        [x2 - left - (tox + tkox) - 2*tdx - tmx, y2 - top - (toy+tkoy) - 2*tdy - tmy],
        [x2 - left - tmx, y2-top-tmy],
        [x2 - left + (tox + tkox) - 2*tdx - tmx, y2 - top + (toy+tkoy) - 2*tdy - tmy],
        [x2 - left + tox - 3*tdx - tmx, y2 - top + toy - 3*tdy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
    case 'point':
    targetStart=2;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - 2*tdx - tmx, y2 - top - toy - 2*tdy - tmy],
        [x2 - left - tmx, y2-top-tmy],
        [x2 - left + tox - 2*tdx - tmx, y2 - top + toy - 2*tdy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
    case 'none':
    default:
    targetStart=0;
      targetPoints = [
        // [x1 - left - tox, y1 - top - toy],
        [x2 - left - tox - tmx, y2 - top - toy - tmy],                    
        [x2 - left + tox - tmx, y2 - top + toy - tmy],
        // [x1 - left + tox, y1 - top + toy]
      ];
      break;
  }

  const sourceK = sourceSize;
  // const hlw = lw>=8?lw:8;

  // const cx = Math.sin(rotation)*curvatureValue;
  // const cy = Math.cos(rotation)*curvatureValue;

  const cpx1 = bends == 2? x1 + cx + (x2-x1)/3:cpx2;
  const cpy1 = bends==2?limitByView(y1 + cy + (y2-y1)/3):cpy2;

  let srotation = Math.atan2(cpy1-y1, cpx1-x1);
  if (srotation < 0){
    srotation = Math.abs(srotation);
  } else {
    srotation = 2 * Math.PI - srotation;
  }


  const sdx = Math.cos(srotation)*hlw*sourceK;
  const sdy = -Math.sin(srotation)*hlw*sourceK;

  const smx = Math.cos(srotation)*sourceMargin;
  const smy = -Math.sin(srotation)*sourceMargin;

  const sox = Math.sin(srotation)*lw*0.5;
  const soy = Math.cos(srotation)*lw*0.5;              

  const skox = Math.sin(srotation)*hlw*0.5*sourceK;
  const skoy = Math.cos(srotation)*hlw*0.5*sourceK;

  
  let sourcePoints;
  let sourceStart;
  switch(sourceShape){
    case 'circle':
      sourceStart=0.95;
      break;
    case 'diamond':
    sourceStart=1.45;
      sourcePoints = [
        // [x1 - left - sox, y1 - top - soy],
        [x1 - left + 2*sdx + smx, y1 - top + 2*sdy + smy],
        [x1 - left - (sox + skox) + sdx + smx, y1 - top - (soy+skoy) + sdy + smy],
        [x1 - left + smx, y1 - top + smy],
        [x1 - left + (sox + skox) + sdx + smx, y1 - top + (soy+skoy) + sdy + smy],
        [x1 - left + 2*sdx + smx, y1 - top + 2*sdy + smy],
        // [x1 - left + sox, y1 - top + soy]
      ];
      break;
    case 'square':
    sourceStart=2;
      sourcePoints = [
        [x1 - left - (sox + skox) + 2*sdx + smx, y1 - top - (soy+skoy) + 2*sdy + smy],
        [x1 - left - (sox + skox) + smx, y1 - top - (soy+skoy) + smy],        
        [x1 - left + (sox + skox) + smx, y1 - top + (soy+skoy) + smy],        
        [x1 - left + (sox + skox) + 2*sdx + smx, y1 - top + (soy+skoy) + 2*sdy + smy],        
      ];
      break;
    case 'none':
    default:
    sourceStart=0;
      sourcePoints = [
        // [x1 - left - sox, y1 - top - soy],
        [x1 - left - sox + smx, y1 - top - soy + smy],                    
        [x1 - left + sox + smx, y1 - top + soy + smy],
        // [x1 - left + sox, y1 - top + soy]
      ];
      break;
  }

  const linkEl = {
    id:link.id+'-line',
    shape:{
      x1: x1 - left + smx + sourceStart*sdx,
      y1: y1 - top + smy + sourceStart*sdy,
      // x1: x1 - left,
      // y1: y1 - top,
      x2: x2 - left - tmx - targetStart*tdx,
      y2: y2 - top - tmy - targetStart*tdy,
      cpx1: cpx1 - left,
      cpy1: cpy1 - top,
      cpx2:cpx2 - left,
      cpy2:cpy2 - top
    }
  };

  if(asElement){
    return [
      {
        ...asElement,
        id: link.id,
        x:left,
        y:top,
        children:[
          linkEl,
          {
            id:link.id+'-target',
            shape:{ points:targetPoints },                    
          },
          {
            id:link.id+'-source',
            type: sourceShape==='circle'?'circle':'polygon',
            shape:sourceShape==='circle'?{
              cx:x1 - left + smx,
              cy: y1 - top + smy,
              r: hlw*sourceK
            }:{ points:sourcePoints },                    
          }
        ]
      }
    ];
  }else{
    return [
      {
        id:link.id,
        x:left,
        y:top,                  
        },
      linkEl,
      {
        id:link.id+'-target',
        shape:{ points:targetPoints },                    
      },
      {
        id:link.id+'-source',
        type: sourceShape==='circle'?'circle':'polygon',
        shape:sourceShape==='circle'?{
          cx:x1 - left + smx,
          cy: y1 - top + smy,
          r: hlw*sourceK
        }:{ points:sourcePoints },                    
      }
    ];
  }
}
